import React from "react";
import GoogleIcon from "../../../images/google-icon.png";

import { googleAuth } from '../../../services/api/auth';


const GoogleAuthentication = (props) => {
    const handleGoogleAuth = async () => {
        const response = await googleAuth()
        window.location = response.data
    }

    return(
        <div className={`flex justify-content-center hover:surface-200 my-1 p-2 goole-microsoft-btns font-normal ${props.isProcmartUser && "google-login-btn-procmart-user"}`} onClick={handleGoogleAuth}>
            <img src={GoogleIcon} alt="Google icon not found" width="18px" height="18px" className="mr-3" />
            <a className=" flex align-items-center ">Login With Google</a>
        </div>
    )
}

export default GoogleAuthentication